var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5752 0H18.6883C17.3492 0 16.2637 1.08553 16.2637 2.42461V11.3115C16.2637 12.6506 17.3492 13.7361 18.6883 13.7361H27.5752C28.9143 13.7361 29.9998 12.6506 29.9998 11.3115V2.42461C29.9998 1.08553 28.9143 0 27.5752 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3115 0H2.42461C1.08553 0 0 1.08553 0 2.42461V11.3115C0 12.6506 1.08553 13.7361 2.42461 13.7361H11.3115C12.6506 13.7361 13.7361 12.6506 13.7361 11.3115V2.42461C13.7361 1.08553 12.6506 0 11.3115 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5752 16.2639H18.6883C17.3492 16.2639 16.2637 17.3494 16.2637 18.6885V27.5754C16.2637 28.9145 17.3492 30 18.6883 30H27.5752C28.9143 30 29.9998 28.9145 29.9998 27.5754V18.6885C29.9998 17.3494 28.9143 16.2639 27.5752 16.2639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3115 16.2639H2.42461C1.08553 16.2639 0 17.3494 0 18.6885V27.5754C0 28.9145 1.08553 30 2.42461 30H11.3115C12.6506 30 13.7361 28.9145 13.7361 27.5754V18.6885C13.7361 17.3494 12.6506 16.2639 11.3115 16.2639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhiteIcon);
export default __webpack_public_path__ + "static/media/dashboard_white_icon.6b1cb4e113312802f11a7d55e353457f.svg";
export { ForwardRef as ReactComponent };